import { render } from "./country-selector.vue?vue&type=template&id=7060e81c"
import script from "./country-selector.vue?vue&type=script&lang=js"
export * from "./country-selector.vue?vue&type=script&lang=js"

import "./country-selector.vue?vue&type=style&index=0&id=7060e81c&lang=scss"

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__